"use client";

import { useQuery } from "@tanstack/react-query";
import { getSharedStakeAdminStatsAction } from "@/resources/actions/admin.actions";
import { queryKeys } from "@/lib/query-keys";

export function useSharedStakeAdminStats() {
  return useQuery({
    queryKey: queryKeys.admin.sharedStake.info(),
    queryFn: async () => {
      const result = await getSharedStakeAdminStatsAction();
      if (result.error) throw new Error(result.error);
      return result.data;
    },
    staleTime: 0,
  });
}
